import { useState } from 'react'

import { CustomCellEditorProps } from 'ag-grid-react'

import { toISO8601 } from '@fortem-monorepo/js-utilities'
import { DatePicker } from '@fortem-monorepo/react-ui'

export interface DateCellEditorProps extends CustomCellEditorProps {}

export const DateCellEditor: React.FC<DateCellEditorProps> = ({
  value,
  onValueChange,
  stopEditing,
}) => {
  const [open, setOpen] = useState(true)
  return (
    <div className={'flex items-center h-full!'}>
      <DatePicker
        open={open}
        onOpenChange={(o) => {
          setOpen(o)
          if (!o) {
            stopEditing()
          }
        }}
        className={'text-xs ag-custom-component-popup w-full min-w-auto! border-0!'}
        selected={value ? new Date(value) : undefined}
        onSelect={(date) => {
          onValueChange(date ? toISO8601(date) : null)
          stopEditing()
        }}
      />
    </div>
  )
}
